// removed by extract-text-webpack-plugin
module.exports = {"noteWrapper":"EhTfisEaiRqdji8Sx0KFR","textareaWrapper":"_3UB5tq4XffP4Ij1ViUsaIS","delete":"_26IlF9yGA-DYWYMd_FQ4VX","save":"_16NPycUGT3fwFjlDEu8RV5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotesProperty/NotePropertyInput.scss
// module id = 1649
// module chunks = 0